import RequestService from './Request'
// import subscription from './user/Subscription';

var get = id => {
	return new Promise((resolve, reject) => {
		var req = {
			url: '/public/user-product/' + id,
			method: 'GET',
			addToken: false
		}
		RequestService.send(req).then(
			res => {
				return resolve(res)
			},
			err => {
				return reject(err)
			}
		)
	})
}

var retryPayment = id => {
	return new Promise((resolve, reject) => {
		var req = {
			url: '/public/user-product/' + id + '/payment',
			method: 'GET',
			addToken: false
		}
		RequestService.send(req).then(
			res => {
				return resolve(res)
			},
			err => {
				return reject(err)
			}
		)
	})
}

var purchase = (
	product_id,
	amount,
	phoneOrEmail,
	name,
	qurbaniInfo = undefined,
	qurbaniDonors = [],
	gateway = undefined,
	subscription = undefined
) => {
	// console.log(product_id, amount, phoneOrEmail, name, gateway)
	return new Promise((resolve, reject) => {
		var req = {
			url: '/public/user-product',
			method: 'POST',
			body: {
				product_id: product_id,
				amount: amount,
				phoneOrEmail: phoneOrEmail,
				name: name,
				qurbaniInfo: qurbaniInfo,
				qurbaniDonors: qurbaniDonors,
				gateway: gateway !== undefined ? gateway : null,
				subscription: subscription !== undefined ? subscription : null
			},
			addToken: false
		}
		RequestService.send(req).then(
			res => {
				return resolve(res)
			},
			err => {
				return reject(err)
			}
		)
	})
}

export default {
	purchase,
	get,
	retryPayment
}
